<template>
<div id="BrandAdd">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增品牌</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="list.length > 1 ? list.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="Dellist(-1)">清空已填模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="AddModelInfo">新增品牌模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackFiles()">返回品牌管理</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in list" :key="index">
            <div class="TTL-form-submit-box-title">品牌模板-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="list.length > 1" @click.stop="Dellist(index)">删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <div class="TTL-image-box-large top20" @click.stop="uploadimages(index)">
                    <el-image :src="item.thumb ? item.thumb : require('@/assets/icon/default-img.png')" fit="cover" />
                    <span>（点击上传封面图片）</span>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">品牌名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.brandname" placeholder="请输入品牌名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>

            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_Brand from '@/Interface/Es/Goods/Brand';
import INTERFACE_MODEL_BASE from '@/Interface/Es/index';
export default {
    components:{},
    data() {
        return {
            limit:10,                                       //限制添加数据条数
            uploadimageIndex:'',                            //图片位置index
            file:'',                                        //文件
            brandinfos:{thumb:'',brandname:''},              //品牌信息               
            list:[],                                        //文件信息
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod() {
            this.ParseData();       //解析之前填写的数据
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.list.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个品牌',type:'warning'});return false;}
            var data=[];
            for(var i in this.list) data.push(this.list[i]);
            data=JSON.stringify(data);

            var obj=document.getElementById("BrandAdd");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_Brand.ADD_BRAND({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.ResetParam(); //重置数据
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
            });
        },


        /** 上传图片信息 **/
        uploadimages(index) {
            this.uploadimageIndex=index;                          //标记当前上传图片序号
            var obj=document.querySelector('#TTLFiles');          //获取文件对象
            obj.click();                                          //点击触发上传图片
            obj.addEventListener('change',this.uploadimagedata);  //添加监听事件
        },


        /** 上传图片信息操作 **/
        uploadimagedata(e) {
            var _this=this;
            this.file=e.target.files[0];       //获取上传的图片
            e.target.value=null;                //清空数据
            document.querySelector('#TTLFiles').removeEventListener('change',this.uploadimagedata);  //解除监听事件

            //上传图片到接口操作
            var obj=document.getElementById("BrandAdd");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_BASE.UPLOAD_FILES({File:this.file}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                _this.list[_this.uploadimageIndex].thumb=res.data.url;
                _this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 新增模板信息 **/
        AddModelInfo() {
            if(this.list.length >= this.limit) {this.$notice({title:'错误提示',message:'新增模板数量不能超过'+this.limit+'个',type:'warning'});return false;}
            var filesinfo={};
            for(var i in this.brandinfos) filesinfo[i]=this.brandinfos[i];
            this.list.push(filesinfo);
            this.SaveDataToBrowser();
        },


        /** 删除模板信息 **/
        Dellist(index) {

            //删除单个模板信息时，无需询问，直接删除
            if(index >=0) {
                this.list.splice(index,1);
                this.SaveDataToBrowser();
                return false;
            } 

            //删除全部模板时先询问再操作
            this.$confirm.confirm(
                '您是否确定要删除当前所有模板文件信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.ResetParam();
            }).catch(()=> {

            });
        },   


        /** 数据重置 **/
        ResetParam() {
             this.list=[];
             var filesinfo={};
             for(var i in this.brandinfos) filesinfo[i]=this.brandinfos[i];
             this.list.push(filesinfo);
             this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 缓存数据到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.list);
            localStorage.setItem('addbrandsdata',data);
        },


        /** 从浏览器提取数据解析 **/
        ParseData() {
            var list=localStorage.getItem('addbrandsdata');
            list && list!='' ?
            this.list=JSON.parse(list) :
            this.ResetParam();
        },


        /** 返回宠物管理组件 **/
        GoBackFiles() {
            var navinfo={name:'品牌管理',labelentry:'Brand',components:'Brand',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>